module.exports = __webpack_public_path__ + "img/swiper1.a345e8a7.jpg";